(function(){
    'use strict';

    angular.module('dataHandlingActionRemoveList', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('actionRemoveListCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionRemoveListCtrl]);

    function actionRemoveListCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayRemoveListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        function resetNode () {
            $scope.search.list = '';
            $scope.displayRemoveListActionOptions = false;
            $scope.showSelectListError = false;
        }

        $rootScope.$on('displayActionRemoveListModal', function(evt, conn, showTip) {
            $scope.contactListData = $rootScope.contactListData;
            $scope.displayRemoveListActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('commons.selectList');

            $timeout(function() {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $scope.sortDataList();
        });

        $rootScope.$on('hideActionRemoveListModal', function() {
            $scope.displayError = false;
            resetNode();
        });

        $rootScope.$on('displayActionRemoveListModalError', function() {
            $scope.displayError = true;
        });

        $scope.sortDataList = () => {
            $scope.contactListData = $scope.contactListData.map((i) => {
                if($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
        };

        $scope.createListClick = () => {
            $scope.createList = true;
            $scope.displayRemoveListActionOptions = false;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = () => {
            if (!$scope.createListName.name) {
                $scope.showNewListNameError = true
            }

            if($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name)
                    .success(({Results}) => {
                        $scope.createListLoader = false;
                        if(Results.length) {
                            const result = Results[0];
                            const listItem = {
                                ContactCount: 0,
                                ListId: result.ListId,
                                ListName: result.ListName
                            };
                            $scope.contactListData.unshift(listItem);
                            $rootScope.contactListData.unshift(listItem);
                            $scope.toggelListItem(result.ListId, 0);
                            $scope.goBackList();
                            $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                        }
                        else {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        }

                    })
                    .error(() => {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        $scope.createListLoader = false;
                    });
            }
        };

        $scope.goBackList = () => {
            $scope.createList = false;
            $scope.displayRemoveListActionOptions = true;
        };

        $scope.cancel = function() {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the remove list
                $rootScope.$broadcast('deleteRemoveListNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showSelectListError = true;
            } else {
                Intercom('trackEvent', 'AP - RemovefromList');
                $rootScope.$emit('saveActionRemoveListData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
            }
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem, $i) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.parseDescription = function(desc, selected) {
            if (desc && typeof desc === 'object'){
                var descriptionCheck = false;
                for (var item in desc){

                    if(desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                        //One list selected and > 19
                        if ( totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                            //More than one selected
                        } else if (totalLists > 1) {
                            desc = totalLists + " " + $scope.translate('commons.selectedList');
                            //One selected but < 19
                        }  else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }

                        break;
                    }
                }
                if(!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }

                }

            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('contactListContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getContactList($rootScope.contactListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.contactListOffset++;
                                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                                    $scope.contactListData = $rootScope.contactListData;
                                    Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                        $scope.contactListData = [];
                        $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                        $scope.sortDataList();
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/actionRemoveListController.js